import { Country, State } from 'country-state-city';

// Get all countries
export const countries = Country.getAllCountries().map(country => ({
  code: country.isoCode,
  name: country.name
})).sort((a, b) => a.name.localeCompare(b.name));

// Get states for each country
export const statesByCountry = Country.getAllCountries().reduce((acc, country) => {
  const states = State.getStatesOfCountry(country.isoCode);
  if (states.length > 0) {
    acc[country.isoCode] = states.map(state => ({
      code: state.isoCode,
      name: state.name
    })).sort((a, b) => a.name.localeCompare(b.name));
  }
  return acc;
}, {} as Record<string, Array<{ code: string; name: string }>>);